
export type DeleteUser500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
